import cardVariables from './cardVariables';

export default cardVariables;
